import { ArchiveBoxIcon } from '@heroicons/react/24/outline';
import { DocumentPreview } from './DocumentPreview';
import type { TFICDocument } from '../types/Document';

export function ArchivedDocumentView({
    document,
    isContentLoading,
}: {
    document: TFICDocument;
    isContentLoading: boolean;
}) {
    return (
        <div className="flex min-h-0 w-full flex-1 flex-col gap-4 p-4">
            <div className="flex items-center gap-3 rounded-md border border-gray-200 bg-gray-50 px-4 py-3">
                <ArchiveBoxIcon className="size-5 shrink-0 text-gray-500" aria-hidden="true" />
                <p className="text-sm text-gray-700">
                    Dit document staat in het archief en wordt niet geboekt.
                </p>
            </div>
            <div className="flex min-h-0 flex-1 overflow-hidden rounded-xl border border-gray-200 bg-gray-100">
                {isContentLoading ? (
                    <img className="m-auto size-12" src="https://app.pocketcfo.io/loader-slow.gif" alt="loader" />
                ) : (
                    <DocumentPreview document={document} />
                )}
            </div>
        </div>
    );
}
